/**
 * SEO-константы проекта
 */

export const DEFAULT_OG_IMAGE_PATH = '/big-logo.webp'

/** Маршруты, которые не должны попадать в индекс */
export const NOINDEX_ROUTE_NAMES = new Set([
  'cart',
  'checkout',
  'login',
  'registration',
  'password-reset',
  'profile',
  'orders',
  'order-detail',
  'addresses',
  'search',
  'not-found'
])

export const PAGE_TITLES = {
  home: 'Интернет-магазин инструментов и оборудования',
  category: 'Каталог',
  product: 'Товар',
  construction: 'Строительство и проектирование',
  about: 'О компании',
  contacts: 'Контакты',
  delivery: 'Доставка и оплата',
  policy: 'Политика конфиденциальности',
  offer: 'Публичная оферта',
  terms: 'Пользовательское соглашение',
  returns: 'Возврат и обмен товара',
  cart: 'Корзина',
  checkout: 'Оформление заказа',
  login: 'Вход',
  registration: 'Регистрация',
  'password-reset': 'Восстановление пароля',
  profile: 'Личный кабинет',
  orders: 'Мои заказы',
  'order-detail': 'Детали заказа',
  addresses: 'Адреса доставки',
  search: 'Поиск',
  'not-found': 'Страница не найдена'
}

export const META_DESCRIPTIONS = {
  home: 'Интернет-магазин инструментов и оборудования для профессионалов. Ручной инструмент, лестницы, сварочное оборудование. Удобный онлайн-сервис и выгодные условия для партнёров.',
  catalog: 'Каталог инструментов и оборудования от компании ООО "КРОН". Широкий ассортимент для профессионалов с оптовыми ценами.',
  allCategories: 'Все товары интернет-магазина ООО "КРОН". Полный ассортимент инструментов и оборудования с сортировкой и поиском.',
  category: 'Товары выбранной категории от компании ООО "КРОН". Широкий ассортимент продукции с оптовыми ценами и быстрым оформлением заказа.',
  cart: 'Корзина покупок компании ООО "КРОН". Просмотрите выбранные товары и оформите заказ.',
  checkout: 'Оформление заказа в интернет-магазине ООО "КРОН". Укажите адрес доставки и контактный телефон.',
  login: 'Вход в личный кабинет интернет-магазина ООО "КРОН". Авторизуйтесь для оформления заказов.',
  registration: 'Регистрация в интернет-магазине ООО "КРОН". Создайте аккаунт для оформления заказов.',
  'password-reset': 'Восстановление пароля в интернет-магазине ООО "КРОН". Сбросьте пароль для доступа к аккаунту.',
  addresses: 'Управление адресами доставки в интернет-магазине ООО "КРОН". Добавляйте и редактируйте адреса для быстрого оформления заказов.',
  user: 'Мои заказы в интернет-магазине ООО "КРОН". Просмотрите все ваши заказы и их статусы.',
  profile: 'Личный кабинет интернет-магазина ООО "КРОН". Профиль, заказы и адреса доставки.',
  orders: 'Мои заказы в интернет-магазине ООО "КРОН". Просмотрите все ваши заказы и их статусы.',
  'order-detail': 'Детали заказа в интернет-магазине ООО "КРОН". Просмотрите подробную информацию о вашем заказе, список товаров и статус доставки.',
  policy: 'Политика конфиденциальности интернет-магазина ООО "КРОН". Узнайте, как мы обрабатываем и защищаем ваши персональные данные.',
  about: 'ООО "КРОН" — надёжный поставщик инструментов и оборудования. Оптовые и розничные поставки по всей России. Широкий ассортимент, выгодные цены, быстрая доставка.',
  construction: 'Строительство, отделочные работы и благоустройство — направление компании «КРОН». Проектирование, дорожные работы и реконструкция объектов под ключ.',
  contacts: 'Контакты компании ООО "КРОН". Адреса офисов и складов в Москве и Ставропольском крае. Телефоны, электронная почта, время работы.',
  delivery: 'Условия доставки и оплаты в интернет-магазине ООО "КРОН". Курьер, самовывоз, транспортные компании. Оплата наличными, картой и по счёту.',
  offer: 'Публичная оферта интернет-магазина ООО "КРОН" — условия договора купли-продажи товаров дистанционным способом.',
  terms: 'Пользовательское соглашение интернет-магазина ООО "КРОН" — правила использования сайта и личного кабинета.',
  returns: 'Условия возврата и обмена товара в интернет-магазине ООО "КРОН". Сроки, порядок возврата и контакты для обращений.',
  search: 'Поиск товаров в интернет-магазине ООО "КРОН".',
  'not-found': 'Запрошенная страница не найдена. Перейдите в каталог интернет-магазина ООО "КРОН".'
}

/** FAQ для AEO — ответы, которые могут цитировать поисковые ИИ */
export const DELIVERY_FAQ = [
  {
    question: 'Какие способы доставки доступны в интернет-магазине КРОН?',
    answer: 'Доступны доставка курьером до двери, самовывоз со склада в Москве или Ставропольском крае, а также отправка транспортной компанией по всей России.'
  },
  {
    question: 'Как можно оплатить заказ в КРОН?',
    answer: 'Оплата возможна наличными при получении, банковской картой онлайн, по счёту для юридических лиц и через СБП.'
  },
  {
    question: 'Сколько времени занимает доставка?',
    answer: 'Срок зависит от региона и способа доставки. По Москве и ближайшему региону — от 1–2 дней, в другие регионы — по тарифам транспортной компании.'
  }
]

export const RETURNS_FAQ = [
  {
    question: 'В какой срок можно вернуть товар в КРОН?',
    answer: 'Покупатель вправе отказаться от товара в течение 7 дней после получения, если сохранены товарный вид, потребительские свойства и документы о покупке.'
  },
  {
    question: 'Как оформить возврат товара?',
    answer: 'Свяжитесь с нами по телефону +7 (495) 799-26-66 или по email info@tovari-kron.ru, сообщите о намерении вернуть товар и согласуйте способ передачи.'
  },
  {
    question: 'Как возвращаются деньги при возврате?',
    answer: 'При оплате картой возврат на карту в течение 10 рабочих дней, при оплате по счёту — на расчётный счёт в течение 10 рабочих дней.'
  }
]

export const CONSTRUCTION_FAQ = [
  {
    question: 'Какие строительные работы выполняет компания КРОН?',
    answer: 'Компания выполняет 8 направлений: общестроительные и бетонные работы, земляные работы, кровельные, фасадные, отделочные работы, демонтаж, строительство и ремонт автомобильных дорог.'
  },
  {
    question: 'Как получить расчёт стоимости строительства в КРОН?',
    answer: 'Отправьте техническое задание или краткое описание объекта на email info@tovari-kron.ru — подготовим смету, сроки и план работ.'
  },
  {
    question: 'Работает ли КРОН по всей России?',
    answer: 'Да, компания выполняет строительные работы и поставляет материалы для объектов в разных регионах России. Склады расположены в Москве и Ставропольском крае.'
  }
]

export const ABOUT_FAQ = [
  {
    question: 'Чем занимается компания КРОН?',
    answer: 'ООО «КРОН» — B2B-поставщик инструментов и оборудования с доставкой по России. Также компания выполняет строительные и отделочные работы под ключ.'
  },
  {
    question: 'Где находятся склады КРОН?',
    answer: 'Склады и офисы компании расположены в Москве (Домодедовское шоссе) и в Ставропольском крае (с. Надежда).'
  }
]
